
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { WorkflowItemProps } from ".";
import { loading, endLoading } from "store/workflow";

interface ApiWorkflowRemoveInputProps {
    ids: number[]
}

type ApiWorkflowRemoveOutputProps = OutputBaseProps<{ item: WorkflowItemProps; }>

export const apiWorkflowRemove = async (data: ApiWorkflowRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiWorkflowRemoveOutputProps>("/api/workflow/remove", { data }))
        .data;
    store.dispatch(endLoading());
    return res;
};